const BaseApi = "https://backend.unchaayi.com/job-board-script/api"


export default BaseApi
